
import { TravelCard } from "../../../components/locations/TravelCard";
import { RajasthanImages } from "../../../media/rajasthan/RajasthanImages";
import PackCard from "../../../components/locations/PackCard";
import contactimg from "../../../media/contactus.png";
import { Link } from "react-router-dom";
import '../MukhaFall/MukhaFall.css';
import { BookSection } from "../../../components/BookSection";


export const Rajdari=()=>{
    return (
       <div className="mukha-fall-container">
         <div className="fancy-heading">
           <h1>Rajdari and Devdari Waterfalls</h1>
           <p className="sub-heading">Waterfalls, surrounded by rugged cliffs, lush greenery, and serene valleys, with gravity magic</p>
         </div>
         <div className="description">
         Rajdari and Devdari Waterfalls, located just 1-2 hours from Varanasi in Chandauli district, are stunning natural marvels within the Chandraprabha Wildlife Sanctuary. These cascading waterfalls, surrounded by rugged cliffs, lush greenery, and serene valleys, offer an unforgettable escape into nature. Rajdari Waterfall enchants visitors with its frothy cascades tumbling over stepped rocky surfaces, while Devdari Waterfall surprises with its pristine, untouched beauty. Once the backdrop of the legendary novel and TV series Chandrakanta, this area also boasts historical significance with nearby ruins like Vijaygarh and Naugarh forts. Perfect for a weekend getaway, the waterfalls are complemented by nearby attractions such as the Aurwatand canyon and Naugarh Dam. Popular as picnic spots among locals and a hidden treasure for travelers, these falls are a testament to the untouched beauty of Uttar Pradesh. Whether you're a nature lover, history enthusiast, or adventure seeker, Rajdari and Devdari Waterfalls are must-visit destinations to rejuvenate your soul amidst nature's splendor.
         </div>
         <div className="image-gallery">
           <div className="image-item">
             <img
               src={require('../../../media/tourism/other/Rajdari Devdari/1.jpg')}
               alt="Mukha Fall 1"
               className="gallery-image"
             />
             {/* <p className="image-caption">The mesmerizing first view of Mukha Fall.</p> */}
           </div>
           <div className="image-item">
             <img
               src={require('../../../media/tourism/other/Rajdari Devdari/2.jpg')}
               alt="Mukha Fall 2"
               className="gallery-image"
             />
             {/* <p className="image-caption">A serene close-up of the cascading waters.</p> */}
           </div>
           <div className="image-item">
             <img
               src={require('../../../media/tourism/other/Rajdari Devdari/3.jpg')}
               alt="Mukha Fall 2"
               className="gallery-image"
             />
             {/* <p className="image-caption">A serene close-up of the cascading waters.</p> */}
           </div>
           <div className="image-item">
             <img
               src={require('../../../media/tourism/other/Rajdari Devdari/4.jpg')}
               alt="Mukha Fall 2"
               className="gallery-image"
             />
             {/* <p className="image-caption">A serene close-up of the cascading waters.</p> */}
           </div>
           <div className="image-item">
             <img
               src={require('../../../media/tourism/other/Rajdari Devdari/5.jpg')}
               alt="Mukha Fall 2"
               className="gallery-image"
             />
             {/* <p className="image-caption">A serene close-up of the cascading waters.</p> */}
           </div>
          
           <div className="image-item">
             <img
               src={require('../../../media/tourism/other/Rajdari Devdari/7.jpg')}
               alt="Mukha Fall 2"
               className="gallery-image"
             />
             {/* <p className="image-caption">A serene close-up of the cascading waters.</p> */}
           </div>
           <div className="image-item">
             <img
               src={require('../../../media/tourism/other/Rajdari Devdari/8.jpg')}
               alt="Mukha Fall 2"
               className="gallery-image"
             />
             {/* <p className="image-caption">A serene close-up of the cascading waters.</p> */}
           </div>
           <div className="image-item">
             <img
               src={require('../../../media/tourism/other/Rajdari Devdari/6.jpg')}
               alt="Mukha Fall 2"
               className="gallery-image"
             />
             {/* <p className="image-caption">A serene close-up of the cascading waters.</p> */}
           </div>
          
          
         </div>
   
         <BookSection />
       </div>
     );
};